import React, { useState, useMemo, useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import InputIcon from '@mui/icons-material/Input';
import { useProperty, getLogger } from '@olympeio/core';
import { executeLambda } from '../../../node/BackendData/LambdaExecutor.js';
import { Typography, DialogContent, Dialog } from '@mui/material';
import { getFormattedLinks, getFormattedDate } from './PotentialUtil.js';
import CloseIcon from '@mui/icons-material/Close';
import { Info } from '@mui/icons-material';
import FeedBackPop from './FeedBackPop.jsx';
import LinearProgress from '@mui/material/LinearProgress';
import CircularProgress from '@mui/material/CircularProgress';
import { _theme } from "../../shared/_theme.js";
import { ThemeProvider } from "@mui/material/styles";

export const EventDetailsPopup = ({ ctx, gridParams }) => {
    const selectedRow = gridParams.row;

    const vendorSiteID = selectedRow.vendorSiteNumber;
    const selectedEvent = useProperty(ctx, 'selected event');
    const [openModal, setOpenModal] = useState(false);
    const [selectedVendorSiteID, setSelectedVendorSiteId] = useState("");
    const [selectedEventIds, setSelectedEventIds] = useState({});
    const [eventDate, setEventDate] = useState('');
    const [lastModifiedDate, setLastModifiedDate] = useState('');
    const [selectedEvents, setSelectedEvents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [eventID, setEventID] = useState('');
    const [error, setError] = useState(false);
    const [selectedCrisisType, setSelectedCrisisType] = useState('');


    const handleOpenModal = () => {
        setAnchorEl1(null);
        setAnchorEl(null);
        setOpenModal(true);
    }

    const handleCloseModal = () => setOpenModal(false);

    const [eventDetails, setEventDetails] = useState({});

    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorEl1, setAnchorEl1] = useState(null);
    const open = Boolean(anchorEl);
    const open1 = Boolean(anchorEl1);
    // Define a memoized function for fetching the product list
    const fetchEventDetails = useMemo(() => async () => {
        setLoading(true);
        try {
            getLogger('fetchEventDetails').log("Making API Call:", selectedVendorSiteID, selectedEventIds);
            if (selectedVendorSiteID && selectedEventIds) {
                const eventData = await executeLambda(ctx, selectedEvent, [selectedEventIds?.toString(), selectedVendorSiteID]); // Replace with your API endpoint
                setSelectedEvents(eventData?.results);
            }
        } catch (error) {
            getLogger('fetchEventDetails').error("Error fetching event details:", error);
            setError(true);
            setLoading(false);
        }
        finally {
            setLoading(false);
        }
    }, [selectedEventIds && selectedVendorSiteID]);

    useEffect(() => {
        fetchEventDetails();
    }, [fetchEventDetails]);

    // Function to handle the opening of the first popup (based on the column selected)
    const handleFirstPopup = async (event, selectdRow) => {
        event.preventDefault();
        const getColumnName = gridParams.colDef.field; // Get the column name from the clicked column
        let eventIds =
          selectdRow?.resEventDetails?.length > 0 &&
          JSON.parse(selectdRow?.resEventDetails).map((elemnt) =>
            Number(elemnt?.event_id)
          );
        setSelectedEventIds(eventIds)
        setSelectedVendorSiteId(selectdRow?.vendorSiteNumber)
        // Code change for fetching the last modified date and format to show side of title - starts
        try {
            setError(false);
            setAnchorEl(event.currentTarget);
            getLogger('handleFirstPopup').log("event details log:", selectedEvents);
        }
        catch (error) {
            getLogger('handleFirstPopup').error("Error fetching event details:", error);
            setError(true);
        }
        // Code change for fetching the last modified date and format to show side of title - ends
        switch (getColumnName) {
            case 'resExtremeWeatherRiskLevel':
                setSelectedCrisisType('Extreme Weather');
                break;
            case 'resPortCongestionRiskLevel':
                setSelectedCrisisType('Port congestion');
                break;
            case 'resGeopoliticalRiskLevel':
                setSelectedCrisisType('Geopolitical');
                break;
            case 'resQualityRiskLevel':
                setSelectedCrisisType('Quality');
                break;
            case 'resOthersRiskLevel':
                setSelectedCrisisType('Others');
                break;
        }
    }
    const handleClose = () => {
        setAnchorEl(null);
        setAnchorEl1(null);
    };

    // The following method formats and returns the disruption and geographic data
    const getFormattedData = (eventDetails, property) => {
        // Checking for blank array and undefined value
        if (eventDetails?.[property] === "[]" ||
            !eventDetails?.[property]) {
            return <>-</>
        }
        else {
            return (
                <>
                    <ul>
                        {JSON.parse(eventDetails?.[property].split(','))?.map((element, index) => (
                            <li key={index}>{element}</li>
                        ))}
                    </ul>
                </>)
        }
    }

    // Function to handle opening the second popup, fetch event details, and format date
    const handleSecondPopup = async (eventid, event) => {
        setAnchorEl(null);
        setAnchorEl1(event.currentTarget);
        setError(false);
        setLoading(true);
        try {
            setEventID(eventid);
            // Execute Lambda function to fetch event details with eventId and VendorSiteID
            const eventData = selectedEvents.filter((element) => element.event_id === eventid)?.[0]
            setEventDetails(eventData)
            // Format event creation date and modified date
            const eventCreatedDate = new Date(selectedEvents?.filter((element) => element.event_id === eventid)[0]?.event_created_date)
            const eventLastModifiedDate = new Date(selectedEvents?.filter((element) => element.event_id === eventid)[0]?.event_last_modified_date)
            //
            const formattedCreatedDate = getFormattedDate(eventCreatedDate);
            const formattedModifiedDate = getFormattedDate(eventLastModifiedDate);
            //
            setEventDate(formattedCreatedDate);
            setLastModifiedDate(formattedModifiedDate);
            setLoading(false);
            getLogger('feedBackLoop').log("event details log:", eventData);
        }
        catch (error) {
            getLogger('feedBackLoop').error("Error fetching event details:", error);
            setError(true);
            setLoading(false);
        }
    }
    return (
      <div className='pct-risk-bubble'>
        <span className='pct-risk-bubble-indicator'></span>
        <IconButton
          size='small'
          sx={{ padding: '1px' }}
          disabled={!(selectedRow?.resEventDetails?.length > 0)}
          onClick={(event) => {
            handleFirstPopup(event, selectedRow);
          }}>
          <Info sx={{ fontSize: '1rem !important' }} />
        </IconButton>
        {/* First Menu for displaying events list  */}
        <Menu
          keepMounted
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              width: 250,
            },
          }}>
          {selectedRow?.resEventDetails?.length > 0 &&
            JSON.parse(selectedRow.resEventDetails).map((events, index) => {
              // List the Crisis event titles with selected crisis type (Selected cell Column header)
              if (events.potentail_crisis_trigger === selectedCrisisType) {
                return loading ? (
                  <div className='pct-event-list-menu'>
                    <CircularProgress size='1rem' />
                  </div>
                ) : error ? (
                  <Typography color='error'>
                    Error loading event data. Please try again.
                  </Typography>
                ) : (
                  <MenuItem className='pct-event-list' key={index}>
                    <div className='pct-event-list-menu'>
                      <div
                        onClick={(event) =>
                          handleSecondPopup(events.event_id, event)
                        }>
                        {events.title} {' - '}
                        {getFormattedDate(
                          selectedEvents?.filter(
                            (element) => element?.event_id === events?.event_id
                          )[0]?.event_last_modified_date
                        )}
                      </div>
                    </div>
                  </MenuItem>
                );
              }
              return null;
            })}
        </Menu>
        {/* Second Menu for detailed event actions and Feedback loop*/}
        <Menu
          anchorEl={anchorEl1}
          open={open1}
          onClose={handleClose}
          PaperProps={{
            style: {
              width: 250,
              height: 'auto',
            },
          }}>
          <div>
            <MenuItem
              onClick={handleOpenModal}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                margin: '5px 0',
              }}>
              <p style={{ margin: '0' }}>View more information</p>
              <InputIcon />
            </MenuItem>
            <hr style={{ margin: '0' }}></hr>

            {loading ? (
              <LinearProgress sx={{ color: 'black' }} />
            ) : error ? (
              <Typography color='error'>
                Error loading Feedback. Please try again.
              </Typography>
            ) : eventDetails.feedback === null ? (
              <FeedBackPop
                ctx={ctx}
                eventID={eventID}
                vendorID={vendorSiteID}
              />
            ) : null}
          </div>
        </Menu>

        {/* Modal with detailed event information */}

        {eventDetails && (
          <ThemeProvider theme={_theme}>
            <Dialog
              onClose={handleCloseModal}
              open={openModal}
              fullWidth={true}
              maxWidth={'md'}>
              <DialogContent className='base-eventDetail-popup'>
                <div className='event-detail-title'>
                  <Typography variant='h6'>
                    {' '}
                    {error
                      ? 'Error loading event details'
                      : `Potential Crisis Trigger: ${eventDetails.potentail_crisis_trigger}`}
                  </Typography>
                  <CloseIcon
                    fontSize='large'
                    sx={{ height: 28, width: 28, cursor: 'pointer' }}
                    onClick={handleCloseModal}
                  />
                </div>
                <div className='eventDetailBody'>
                  {error ? (
                    <Typography className='errorBody' color='error'>
                      There was an error loading the event details. Please try
                      again later.
                    </Typography>
                  ) : (
                    <>
                      <Typography className='eventTitle' variant='h4'>
                        {eventDetails.title}
                      </Typography>
                      <Typography variant='body1'>
                        Last Modified Date: {lastModifiedDate}
                      </Typography>
                      <Typography variant='body1'>
                        Created Date: {eventDate}
                      </Typography>
                      <hr />
                      <Typography className='bodyLight' variant='body1'>
                        Severity:{' '}
                        <span className='subtitleText'>
                          {eventDetails.severity}
                        </span>
                      </Typography>

                      <Typography className='bodyTitle' variant='h6'>
                        {eventDetails.event_bulletins_title}
                      </Typography>
                      <Typography className='bodyContent'>
                        {eventDetails.event_bulletins_sub_title}
                      </Typography>
                      <Typography className='bodyContent'>
                        {eventDetails.description}
                      </Typography>
                      <Typography className='bodyContent'>
                        {eventDetails.event_bulletins_summary}
                      </Typography>

                      <Typography className='subtitleText' variant='subtitle1'>
                        Companies affected:
                      </Typography>
                      <div className='bodyContent'>
                        <ul
                          dangerouslySetInnerHTML={{
                            __html:
                              eventDetails?.event_bulletins_companies_affected
                                ?.replaceAll(/'/g, '"')
                                .replaceAll(/\["/g, '')
                                .replaceAll(/"]/g, '')
                                .replaceAll(/"/g, '')
                                .replaceAll(/,/g, '')
                                .replaceAll('/\\', ''),
                          }}
                        />
                      </div>
                      <Typography className='subtitleText' variant='subtitle1'>
                        Disruption observed:
                      </Typography>
                      <div className='bodyContent'>
                        {getFormattedData(
                          eventDetails,
                          'event_bulletins_disruptions_observed'
                        )}
                      </div>
                      <Typography className='subtitleText' variant='subtitle1'>
                        Geographic regions affected:
                      </Typography>
                      <div className='bodyContent'>
                        {getFormattedData(
                          eventDetails,
                          'event_bulletins_geographic_regions_affected'
                        )}
                      </div>
                      <Typography className='subtitleText' variant='subtitle1'>
                        Related links:
                      </Typography>
                      <div className='bodyContent'>
                        <ul
                          dangerouslySetInnerHTML={{
                            __html: getFormattedLinks(eventDetails),
                          }}
                        />
                      </div>
                    </>
                  )}
                </div>
              </DialogContent>
            </Dialog>
          </ThemeProvider>
        )}
      </div>
    );
}